import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServiceProvider } from '../service/service.provider';
import { map } from 'rxjs/operators';
import { LocalStorageService } from '../../shared/local-storage.service'
import { Router, ActivatedRoute } from '@angular/router';

import { User } from '../../shared/models/user.model';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    // private currentUserSubject: BehaviorSubject<User>;
    // public currentUser: Observable<User>;

    constructor(public dataService: ServiceProvider, private storage: LocalStorageService, private router: Router) {
        // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        // this.currentUser = this.currentUserSubject.asObservable();
    }

    // public get currentUserValue(): User {
    //     return this.currentUserSubject.value;
    // }

        

    login(userName: any, userPassword: any) {
        const requestQuery = {
            user_mail: userName,
            password: userPassword
          };
        return this.dataService.post('login', null, requestQuery)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem('currentUser', JSON.stringify(user));
                // this.currentUserSubject.next(user);
                return user;
            }));
    }

    logout() {
        // const bodyQuery = {
        //     token: localStorage.getItem('accessToken')
        // }
        this.dataService.get('logout').subscribe(data => {
            console.log('Logout successfully!');
        }, (err) => {
            console.log(err);
        });
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        // this.currentUserSubject.next(null);
        return true
    }
}
